import {Component, Input, Output, SimpleChanges, EventEmitter, ViewChild, ElementRef, forwardRef} from '@angular/core';
import {SistemaService} from '../../Servicios/Sistema.Service';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {AppService} from '../../app.service';
import { DxTreeViewComponent } from 'devextreme-angular';

declare var $: any;
declare function Focus(id : string) : any;

const noop = () =>
{
};

export const CUSTOM_MULTISELECT_CONTROL_VALUE_ACCESSOR: any =
  {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => MultiSelectTreeViewComponent),
    multi: true
  };

@Component(
  {
    selector: 'multiSelecttreeview',
    templateUrl: './multiSelectTreeView.template.html',
    styleUrls: ['./MultiSelectTreeView.scss'],
    providers: [CUSTOM_MULTISELECT_CONTROL_VALUE_ACCESSOR]
  })

export class MultiSelectTreeViewComponent implements ControlValueAccessor
{
  @ViewChild('ddMenu') ddMenu! : ElementRef;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView!: DxTreeViewComponent;

  public innerValue : string = "";
  public datoSeleccionado : any;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  @Input() titulo : string = ""; // titulo del multiselect
  @Input() opciones : any[] = []; // lista de opciones
  @Input() valorName : string = ""; // nombre del atributo que se identificara como seleccionado, por ejemplo el id
  @Input() displayValor : string = ""; // nombre del que se desplegará
  @Input() displayValorIcon : string = ""; // icono que se desplegará junto al nombre
  @Input() displayValorView : number = 1; // nombre dentro del tree view que se va a mostrar depende de la variable "tipo"

  @Input() buscar : boolean = true; // indica si se mostrará el campo de busqueda
  @Input() listaselect : string = "";
  @Input() limpiarInput : boolean = true; // muestra o no el botón para limpiar la seleccion
  @Input() seleccionarTodos : boolean = true; // muestra o no el botón para seleccionar todos

  @Input() margenControl : boolean = true; // indica si el control lleva un margen de 30px (se recomienda para que el control sea responsivo automáticamente)

  @Input() clasesAdicionales : string = ""; // clases que se agregan al control

  @Input() errorActivo : boolean = false; // indica si el error esta habilitado para mostrarse
  @Input() verError : boolean = true; // indica si se muestra el error
  @Input() disabled : boolean = false; // indica si el control esta deshabilitado
  @Input() mensajeError : string = "Selecciona al menos una opción"; // mensaje que desplegará cuando haya un error

  public busqueda : string = ""; // campo de busqueda

  public id : number = 0;
  public seleccionadosTodos : boolean = false;
  public cadenaSeleccionados : string = "";

  constructor(public sistemaService : SistemaService, public appService : AppService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
  }

  ngOnInit() {
    this.EvitarCierre()
  }

  treeViewSelectionChanged(e:any) {
    this.EvitarCierre();
    this.syncSelection(e.component);
  }

  syncSelection(treeView:any) {
    let selectedEmployees = treeView.getSelectedNodes().map((node:any) => {
      if(node.itemData.tipo == this.displayValorView){
        return node.itemData
      }
    });
    //this.valor = selectedEmployees;

    this.EvitarCierre();

    let seleccionado = [];
    // set dato
    if (selectedEmployees){
      for(let data of selectedEmployees){
        if(data){
          seleccionado.push(data.obj);
        }
      }
    }
    else{
      seleccionado = [];
    }

    this.valor = seleccionado;

  }

  SetDatoSelecciondo() {
    this.datoSeleccionado = [];
    this.cadenaSeleccionados = "";
    let selectedEmployees = [];
    if(this.treeView){
      selectedEmployees = this.treeView.instance.getSelectedNodes().map((node:any) => {
        if(node.itemData.tipo == this.displayValorView){
          return node.itemData
        }
      });
      if(selectedEmployees.length == 0 && this.valor.length > 0 && this.listaselect != ""){
        this.cadenaSeleccionados = "";
        for(let id of this.listaselect.split(", ")){
          this.treeView.instance.selectItem(id)
        }
      }
    }

    if (this.valor) {
      for(let k = 0; k < selectedEmployees.length; k++) {
          for (let i = 0; i < this.valor.length; i++) {
            if(selectedEmployees[k]){
              if (selectedEmployees[k].obj[this.valorName] == this.valor[i][this.valorName]) {
                this.datoSeleccionado.push(selectedEmployees[k].obj);
                this.cadenaSeleccionados += selectedEmployees[k][this.displayValor] + ", ";
              }
            }
          }
      }

      this.cadenaSeleccionados = this.cadenaSeleccionados.substr(0 , this.cadenaSeleccionados.length - 2);

    }
  }

  LimpiarSelect() {
    this.EvitarCierre();

    this.valor = [];
    this.seleccionadosTodos = false;
  }

  LimpiarBusqueda() {
    this.EvitarCierre();
    this.FocusBuscar();
  }

  FocusBuscar() {
    if (this.buscar) {
      this.busqueda = '';

      setTimeout(() => {
        Focus('buscar' + this.id);
      }, 0);
    }
  }

  EvitarCierre()
  {

    $('#treeview').click(function(e : any)
    {
      e.stopPropagation();
    });
  }

  // control ngModel
  get valor(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set valor(nuevoValor: any) {
    if (nuevoValor !== this.innerValue) {
      this.innerValue = nuevoValor;
      this.SetDatoSelecciondo();
      this.onChangeCallback(nuevoValor);
    }
  }

  writeValue(valor: any) {
    if (valor !== this.innerValue) {
      this.innerValue = valor;
      this.SetDatoSelecciondo();
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }
}
